<template>
  <div>
    <location />
    <div id="brs" class="page wrap-1200">
      <h3 class="subtitle">{{ $t("title.membership.golf_shot") }}</h3>
      <div class="specs card">
        <div v-b-toggle.collapse-spec class="collapse-content">
          <div class="me-3">
            <p class="mb-2 goods-kind">
              <span class="brand-name">{{
                fittinginfo.goodsinfo.fit_brand_nm
              }}</span
              >{{ fittinginfo.goodsinfo.goodstype | get_club_type }}({{
                fittinginfo.goodsinfo.clubtype_code_name
              }})
            </p>
            <p class="goods-name">{{ fittinginfo.goodsinfo.goodsname }}</p>
          </div>
        </div>
        <b-collapse visible id="collapse-spec" class="current-spec border-top">
          <b-card class="border-0" body-class="pt-3">
            <div class="row g-3 g-lg-4">
              <div class="col-lg-7">
                <h6 class="mb-2 small">
                  {{ $t("title.common.club_spec") }}
                </h6>
                <div class="row g-0 table-type header-col border-1">
                  <div class="col">{{ $t("title.common.loft") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodsloft !== '-' ? fittinginfo.goodsinfo.goodsloft + '°' : '-' }}
                  </div>
                  <div class="col">{{ $t("title.common.lie") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodslie !== '-' ? fittinginfo.goodsinfo.goodslie + '°' : '-' }}
                  </div>
                  <div class="col">{{ $t("title.common.sole") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodssole !== '-' ? fittinginfo.goodsinfo.goodssole + '°' : '-' }}
                  </div>
                  <div class="col">{{ $t("title.common.fp") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodsfp !== '-' ? fittinginfo.goodsinfo.goodsfp + 'mm' : '-' }}
                  </div>
                  <div class="col">{{ $t("title.common.length") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodslength !== '-' ? fittinginfo.goodsinfo.goodslength + 'inch' : '-' }}
                  </div>
                  <div class="col">{{ $t("title.common.total_weight") }}</div>
                  <div class="col">
                    {{ fittinginfo.goodsinfo.goodsweight !== '-' ? fittinginfo.goodsinfo.goodsweight + 'g' : '-' }}
                  </div>
                </div>
              </div>

              <div class="col-lg-5">
                <div class="shaft-info">
                  <h6 class="mb-2 small">
                    {{ $t("title.common.shaft_spec") }}
                  </h6>
                  <div class="row g-0 table-type header-col border-1 border-bottom-0">
                    <div class="col flex-fill bg-white">
                      {{ fittinginfo.goodsinfo.shaftname || "-" }}
                    </div>
                  </div>
                  <div class="row g-0 table-type header-col border-top">
                    <div class="col">{{ $t("title.common.material") }}</div>
                    <div class="col flex-fill">
                      {{ fittinginfo.goodsinfo.shaftmaterial ? (fittinginfo.goodsinfo.shaftmaterial | get_shaft_material) : '-' }}
                    </div>
                    <div class="col">{{ $t("title.common.flex") }}</div>
                    <div class="col flex-fill align-self-center">
                      {{ fittinginfo.goodsinfo.shaftflextype ? (fittinginfo.goodsinfo.shaftflextype | get_balance) : '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-collapse>
      </div>
      <!-- //스펙 -->

      <div class="d-flex justify-content-between align-items-center my-2">
        <div id="popover-container">
          <b-button id="basic-info" href="#" tabindex="0" class="btn-text"
            ><span class="material-icons-outlined me-1">info</span
            >{{ $t("button.membership.registration_info") }}</b-button
          >
          <b-popover
            target="basic-info"
            container="popover-container"
            placement="bottomleft"
            custom-class="popover-reg-info"
          >
            <ul class="list-unstyled fs-14">
              <li>
                <strong>{{ $t("title.common.nickname") }}</strong>
                <span class="text-secondary"
                  ><MemberInfo
                    :nickname="fittinginfo.swingdetailinfo.nickname"
                    :playerno="fittinginfo.swingdetailinfo.memberno"
                  />
                  <!-- <span class="material-icons-outlined fs-6"
                  >help_outline</span> -->
                </span>
              </li>
              <li>
                <strong>{{ $t("title.common.location") }}</strong
                ><span class="text-secondary">{{
                  fittinginfo.swingdetailinfo.shopname
                }}</span>
              </li>
              <li>
                <strong>{{ $t("title.membership.application_date") }}</strong
                ><span class="text-date">{{
                  fittinginfo.swingdetailinfo.regdate
                }}</span>
              </li>
            </ul>
          </b-popover>
        </div>

        <b-button class="btn-text" @click="$bvModal.show('modal-shot-list')">
          <span class="material-icons-outlined me-1">list_alt</span
          >{{ $t("button.common.shot_list") }}
        </b-button>
        <b-modal
          id="modal-shot-list"
          size="lg"
          centered
          scrollable
          hide-footer
          modal-class="modal-slideup"
          footer-class="btn-bottom-wrapper"
        >
          <template #modal-header>
            <h3>{{ $t("title.common.shot_list") }}</h3>
            <b-button
              variant="close"
              :aria-label="$t('button.common.close')"
              @click="$bvModal.hide('modal-shot-list')"
            >
            </b-button>
          </template>

          <template>
            <div class="row g-1 row-cols-2 row-cols-sm-4 mb-3">
              <div class="col">
                <select
                  :aria-label="$t('text.membership.search_requirement')"
                  v-model="searchData.goodstype"
                >
                  <option value="">{{ $t("filter.common.total") }}</option>
                  <option
                    v-for="val in swingkeyset"
                    :key="'goodstype' + val"
                    :value="val"
                  >
                    {{ val | get_club_type }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select
                  :aria-label="$t('filter.membership.shot_selection')"
                  v-model="searchData.no"
                >
                  <option value="0">
                    {{ $t("filter.membership.shot_selection") }}
                  </option>
                  <option
                    v-for="val in items.swinginfo.filter((v) =>
                      searchData.goodstype
                        ? v.goodstype == searchData.goodstype
                        : true
                    )"
                    :key="'fit_shotdata_pk' + val.fit_shotdata_pk"
                    :value="val.fit_shotdata_pk"
                  >
                    #{{ val.no }}
                  </option>
                </select>
              </div>
            </div>

            <div class="accordion list-type" role="tablist">
              <template
                v-for="val in Array.from(swingkeyset).filter((v) =>
                  searchData.goodstype ? v == searchData.goodstype : true
                )"
              >
                <template
                  v-for="(item, idx) in items.swinginfo.filter(
                    (v) => v.goodstype == val
                  )"
                >
                  <b-card no-body class="rounded-0" :key="item.fit_shotdata_pk">
                    <b-card-header header-tag="header" role="tab">
                      <div
                        v-b-toggle="'shot-no' + item.fit_shotdata_pk"
                        class="collapse-content"
                        @click="
                          get_fittingswingview(fittingno, item.fit_shotdata_pk)
                        "
                      >
                        <div class="row g-2 row-cols-auto me-2 fs-14">
                          <div class="d-flex col align-items-center">
                            <span
                              class="video-state me-1"
                              :class="{
                                'has-video': item.fit_swing_video_name,
                              }"
                            >
                            </span>
                            <strong class="text-black">#{{ item.no }}</strong>
                          </div>
                          <div class="col">
                            <span class="material-icons pe-1 fs-6 text-pink"
                              >flag</span
                            >
                            <span class="goods-kind">{{
                              item.goodstype | get_club_code
                            }}</span>
                          </div>
                          <div class="col text-nowrap">
                            <strong class="text-black">{{
                              $t("title.membership.distance")
                            }}</strong>
                            {{ item.distance | toFixed }}m
                          </div>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :id="'shot-no' + item.fit_shotdata_pk"
                      :visible="
                        searchData.no
                          ? searchData.no == item.fit_shotdata_pk
                          : idx == 0
                      "
                      accordion="shot-list-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0">
                        <div
                          class="row g-0 table-type header-col size-sm row-cols-2 row-cols-sm-4 row-cols-lg-6"
                        >
                          <div class="col">
                            {{ $t("text.membership.carry") }}
                          </div>
                          <div class="col">{{ item.carry | toFixed }}m</div>
                          <div class="col">
                            {{ $t("text.membership.ball_speed") }}
                          </div>
                          <div class="col">
                            {{ item.ballspeed | toFixed }}m/s
                          </div>
                          <div class="col">
                            {{ $t("text.membership.ball_direction") }}
                          </div>
                          <div class="col">
                            {{ item.balldirection | toFixed }}°
                          </div>
                          <div class="col">
                            {{ $t("text.common.launch_angle") }}
                          </div>
                          <div class="col">
                            {{ item.launchangle | toFixed }}°
                          </div>
                          <div class="col">
                            {{ $t("text.membership.backspin") }}
                          </div>
                          <div class="col">
                            {{ item.backspin | toFixed }}rpm
                          </div>
                          <div class="col">
                            {{ $t("title.membership.sidespin") }}
                          </div>
                          <div class="col">
                            {{ item.sidespin | toFixed }}rpm
                          </div>
                          <div class="col">
                            {{ $t("title.membership.separation_distance") }}
                          </div>
                          <div class="col">
                            {{ item.seperationdistance | toFixed }}m
                          </div>
                          <div class="col">
                            {{ $t("title.membership.vertical_peak") }}
                          </div>
                          <div class="col">
                            {{ item.peakvertical | toFixed }}m
                          </div>
                          <div class="col">
                            {{ $t("title.membership.flight_time") }}
                          </div>
                          <div class="col">{{ item.duration | toFixed }}s</div>
                          <div class="col">
                            {{ $t("title.membership.horizontal_peak") }}
                          </div>
                          <div class="col">
                            {{ item.peakhorizontal | toFixed }}m
                          </div>
                          <div class="col">
                            {{ $t("title.membership.head_speed") }}
                          </div>
                          <div class="col">
                            {{ item.headspeed | toFixed }}m/s
                          </div>
                          <div class="col border-bottom-0">
                            {{ $t("title.membership.meat_rate") }}
                          </div>
                          <div class="col">
                            {{ item.smashfactor | toFixed }}%
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </template>
                <b-card no-body class="rounded-0" :key="'avg' + val">
                  <b-card-header header-tag="header" role="tab">
                    <div
                      v-b-toggle="'shot-avg' + val"
                      class="collapse-content bg-light"
                    >
                      <div class="row g-2 row-cols-auto me-2 fs-14">
                        <div class="d-flex col align-items-center">
                          <strong class="text-black"
                            >{{ val | get_club_code }}
                            {{ $t("text.common.avg") }}</strong
                          >
                        </div>
                        <div class="vr mx-2 p-0"></div>
                        <div class="col text-nowrap">
                          <strong class="text-black">{{
                            $t("title.membership.distance")
                          }}</strong>
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.distance)) || [0]
                            ) | toFixed
                          }}
                          m
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    :id="'shot-avg' + val"
                    accordion="shot-list-accordion"
                    role="tabpanel"
                  >
                    <b-card-body class="p-0">
                      <div
                        class="row g-0 table-type header-col size-sm row-cols-4 row-cols-sm-6"
                      >
                        <div class="col">
                          {{ $t("title.membership.carry") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.carry)) || [0]
                            ) | toFixed
                          }}
                          m
                        </div>
                        <div class="col">
                          {{ $t("title.membership.ball_speed") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.ballspeed)) || [0]
                            ) | toFixed
                          }}m/s
                        </div>
                        <div class="col">
                          {{ $t("title.membership.ball_direction") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.balldirection)) || [0]
                            ) | toFixed
                          }}°
                        </div>
                        <div class="col">
                          {{ $t("title.membership.launch_angle") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.launchangle)) || [0]
                            ) | toFixed
                          }}°
                        </div>
                        <div class="col">
                          {{ $t("title.membership.backspin") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.backspin)) || [0]
                            ) | toFixed
                          }}rpm
                        </div>
                        <div class="col">
                          {{ $t("title.membership.sidespin") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.sidespin)) || [0]
                            ) | toFixed
                          }}rpm
                        </div>
                        <div class="col">
                          {{ $t("title.membership.separation_distance") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.seperationdistance)) || [0]
                            ) | toFixed
                          }}m
                        </div>
                        <div class="col">
                          {{ $t("title.membership.vertical_peak") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.peakvertical)) || [0]
                            ) | toFixed
                          }}m
                        </div>
                        <div class="col">
                          {{ $t("title.membership.flight_time") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.duration)) || [0]
                            ) | toFixed
                          }}s
                        </div>
                        <div class="col">
                          {{ $t("title.membership.horizontal_peak") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.peakhorizontal)) || [0]
                            ) | toFixed
                          }}m
                        </div>
                        <div class="col">
                          {{ $t("title.membership.head_speed") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.headspeed)) || [0]
                            ) | toFixed
                          }}m/s
                        </div>
                        <div class="col">
                          {{ $t("title.membership.meat_rate") }}
                        </div>
                        <div class="col">
                          {{
                            average(
                              (items.swinginfo.filter(
                                (v) => v.goodstype == val
                              ) &&
                                items.swinginfo
                                  .filter((v) => v.goodstype == val)
                                  .map((v) => v.smashfactor)) || [0]
                            ) | toFixed
                          }}%
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </template>
            </div>
            <!-- //accordion -->
          </template> </b-modal
        ><!-- // 팝업, 샷 목록 -->
      </div>
      <!-- //등록정보, 샷 목록 -->

      <section class="swing-anls mt-0">
        <div class="row">
          <div class="col-lg-12 flex-column">
            <div class="item h-100 d-flex flex-column">
              <div class="row">
                <video-player
                  ref="player1"
                  class="video-player vjs-custom-skin col-lg-6 flex-column"
                  :playsinline="true"
                  :options="playerOptions"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @ready="(player) => onPlayerReady(player)"
                >
                </video-player>
                <video-player
                  ref="player2"
                  class="video-player vjs-custom-skin col-lg-6 flex-column"
                  :playsinline="true"
                  :options="playerOptions2"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @ready="(player) => onPlayerReady2(player)"
                >
                </video-player>
              </div>

              <div class="row swing-seq g-0">
                <div
                  class="col"
                  :class="{ active: videoControl == 'address' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_address > -1
                        ? fittinginfo.swingdetailinfo.fit_address
                        : 50,
                      'address'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.address")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step1.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'backswing' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_takeback > -1
                        ? fittinginfo.swingdetailinfo.fit_takeback
                        : 100,
                      'backswing'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.back_swing")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step2.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'topswing' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_top_swing > -1
                        ? fittinginfo.swingdetailinfo.fit_top_swing
                        : 170,
                      'topswing'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.top_swing")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step3.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'downswing' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_down_swing > -1
                        ? fittinginfo.swingdetailinfo.fit_down_swing
                        : 230,

                      'downswing'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.down_swing")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step4.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'impact' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_impact > -1
                        ? fittinginfo.swingdetailinfo.fit_impact
                        : 290,

                      'impact'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.impact")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step5.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'follow' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_follow > -1
                        ? fittinginfo.swingdetailinfo.fit_follow
                        : 350,

                      'follow'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.follow_through")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step6.svg"
                  />
                </div>
                <div
                  class="col"
                  :class="{ active: videoControl == 'finish' }"
                  @click="
                    setPlayerframe(
                      fittinginfo.swingdetailinfo.fit_finish > -1
                        ? fittinginfo.swingdetailinfo.fit_finish
                        : 410,

                      'finish'
                    )
                  "
                >
                  <span class="d-none d-sm-inline-block">{{
                    $t("text.common.finish")
                  }}</span>
                  <img
                    class="d-sm-none d-inline-block img-fluid"
                    src="/img/swing-seq-step7.svg"
                  />
                </div>
              </div>
              <!-- golf swing sequence : 7가지 구분 동작 -->

              <div class="swing-wt g-0 item h-100">
                <div class="wt-info">
                  <div class="wt-value">
                    <!-- 좌우전후 -->
                    <div
                      class="position-absolute top-0 start-50 translate-middle-x text-green"
                    >
                      L
                      <input ref="chartDataL" value="0" />
                    </div>
                    <div
                      class="position-absolute bottom-0 start-50 translate-middle-x text-green"
                    >
                      R <input ref="chartDataR" value="0" />
                    </div>
                    <div
                      class="position-absolute top-50 end-0 translate-middle-y text-orange bg-white"
                    >
                      F <input ref="chartDataF" value="0" />
                    </div>
                    <div
                      class="position-absolute top-50 start-0 translate-middle-y text-orange bg-white"
                    >
                      B <input ref="chartDataB" value="0" />
                    </div>
                  </div>

                  <LineChartGenerator
                    class="wt-graph"
                    :chart-options="chartConfig.options"
                    :chart-data="chartConfig.data"
                  />
                </div>
              </div>
              <!-- 체중그래프 -->
            </div>
          </div>

          <!-- col-md-8 -->
        </div>
        <div class="row">
          <div class="col-lg-4 flex-column flex-md-row flex-lg-column">
            <LineChartGenerator
              class="col item"
              :chart-options="{
                ...chartConfigSide.options,
                onClick: (point, event) => {
                  $bvModal.show('modal-traj-side');
                },
                pointRadius: function (context) {
                  if (context.dataIndex == context.dataset.data.length - 1) {
                    return 5;
                  } else {
                    return 0;
                  }
                },
              }"
              :chart-data="chartConfigSide.data"
              :height="183"
            />
            <!-- <div
              class=""
              @click="$bvModal.show('modal-traj-side')"
            >

            </div> -->
            <!-- <div
              class=""
              @click="$bvModal.show('modal-traj-top')"
            >
              <div class=""></div>
            </div> -->
          </div>
          <div class="col-lg-4 flex-column flex-md-row flex-lg-column">
            <LineChartGenerator
              class="col item mx-md-2 mx-lg-0 my-2 my-md-0 my-lg-2"
              :chart-options="{
                ...chartConfigTop.options,
                onClick: (point, event) => {
                  $bvModal.show('modal-traj-top');
                },
                pointRadius: function (context) {
                  if (context.dataIndex == context.dataset.data.length - 1) {
                    return 5;
                  } else {
                    return 0;
                  }
                },
              }"
              :chart-data="chartConfigTop.data"
              :height="183"
            />
          </div>
          <div class="col-lg-4 flex-column flex-md-row flex-lg-column">
            <div class="col item" @click="$bvModal.show('modal-traj-club')">
              <img :src="getFitImagePath()" class="img-fluid mh-100" />
            </div>
          </div>
          <!-- col-md-4 -->
        </div>
      </section>
      <!-- //골프 스윙분석 -->

      <b-modal
        id="modal-traj-side"
        size="lg"
        centered
        scrollable
        footer-class="btn-bottom-wrapper"
      >
        <template #modal-header>
          <h3>{{ $t("title.membership.trajectory_side_view") }}</h3>
          <b-button
            variant="close"
            :aria-label="$t('button.common.close')"
            @click="$bvModal.hide('modal-traj-side')"
          >
          </b-button>
        </template>

        <template>
          <LineChartGenerator
            :chart-options="chartConfigSide.options"
            :chart-data="chartConfigSide.data"
          />
        </template>

        <template #modal-footer="{ cancel }">
          <b-button
            size="md"
            variant="outline-secondary"
            :aria-label="$t('button.common.close')"
            @click="cancel()"
          >
            {{ $t("button.common.close") }}
          </b-button>
          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.printed')"
            @click="printPage()"
          >
            {{ $t("button.common.printed") }}
          </b-button>
        </template> </b-modal
      ><!-- // 팝업, 궤적 측면 뷰 -->

      <b-modal
        id="modal-traj-top"
        size="lg"
        centered
        scrollable
        footer-class="btn-bottom-wrapper"
      >
        <template #modal-header>
          <h3>{{ $t("title.membership.trajectory_top_view") }}</h3>
          <b-button
            variant="close"
            :aria-label="$t('button.common.close')"
            @click="$bvModal.hide('modal-traj-top')"
          >
          </b-button>
        </template>

        <template>
          <LineChartGenerator
            :chart-options="chartConfigTop.options"
            :chart-data="chartConfigTop.data"
          />
        </template>

        <template #modal-footer="{ cancel }">
          <b-button
            size="md"
            variant="outline-secondary"
            :aria-label="$t('button.common.close')"
            @click="cancel()"
          >
            {{ $t("button.common.close") }}
          </b-button>
          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.printed')"
            @click="printPage()"
          >
            {{ $t("button.common.printed") }}
          </b-button>
        </template> </b-modal
      ><!-- // 팝업, 궤적 상단 뷰 -->

      <b-modal
        id="modal-traj-club"
        size="lg"
        centered
        scrollable
        footer-class="btn-bottom-wrapper"
      >
        <template #modal-header>
          <h3>{{ $t("title.membership.club_pass") }}</h3>
          <b-button
            variant="close"
            :aria-label="$t('button.common.close')"
            @click="$bvModal.hide('modal-traj-club')"
          >
          </b-button>
        </template>

        <template>
          <div class="bg-light">
            <img :src="getFitImagePath()" class="img-fluid mh-100" />
          </div>
        </template>

        <template #modal-footer="{ cancel }">
          <b-button
            size="md"
            variant="outline-secondary"
            :aria-label="$t('button.common.close')"
            @click="cancel()"
          >
            {{ $t("button.common.close") }}
          </b-button>
          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.printed')"
            @click="printPage()"
          >
            {{ $t("button.common.printed") }}
          </b-button>
        </template> </b-modal
      ><!-- // 팝업, 클럽 패스 -->

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-secondary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'FittingList',
              query: { goodstype: $route.query.goodstype },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
        <b-button
          size="xl"
          variant="secondary"
          :aria-label="$t('button.common.shot_list')"
          @click="$bvModal.show('modal-shot-list')"
          >{{ $t("button.common.shot_list") }}</b-button
        >
        <!-- <b-button
          size="xl"
          variant="primary"
          aria-label="피팅내역"
          v-if="fitinfo.state_cd != '0'"
          @click="
            $router.push({
              name: 'FittingAnswerView',
              params: {
                fitreqno: fitinfo.fit_req_pk,
              },
              query: { goodstype: $route.query.goodstype },
            })
          "
          >피팅내역</b-button
        > -->

        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('text.membership.fitting_apply')"
          v-if="fitinfo.fit_req_pk == null"
          @click="
            $router.push({
              name: 'FittingRequestWrite',
              params: {
                fittingno: fitinfo.fit_pk,
              },
              query: { goodstype: $route.query.goodstype },
            })
          "
          >{{ $t("text.membership.fitting_apply") }}</b-button
        >

        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.membership.fitting_view')"
          v-if="fitinfo.fit_req_pk && fitinfo.state_cd > 0"
          @click="
            $router.push({
              name: 'FittingAnswerView',
              params: {
                fitreqno: fitinfo.fit_req_pk,
              },
              query: { goodstype: $route.query.goodstype },
            })
          "
          >{{ $t("button.membership.fitting_view") }}</b-button
        >
      </div>
      <!-- //btn-bottom-wrapper -->
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/fitting";

import "@/filter/common";
// import VideoPlayer from "vue-video-player";
// import videojs from "video.js";

import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

export default {
  name: "FittingSwingList",
  components: {
    location,
    LineChartGenerator,
  },
  data() {
    return {
      isReady1: false,
      isReady2: false,
      player1: null,
      player2: null,
      canPlay1: false,
      canPlay2: false,
      isManualPause: false,
      wordLR: [],
      chartDataLR: [],
      chartDataFB: [],
      chartConfig: { options: {}, data: {} },

      chartDataSide: [],
      chartConfigSide: {
        options: {
          onClick: (point, event) => {
            this.$bvModal.show("modal-traj-side");
            console.log("event : ", event);
            console.log("point : ", point);
          },
          interaction: {
            intersect: false,
          },
          plugins: {
            tooltip: { enabled: false },
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              type: "linear",
              suggestedMax: 300,
            },
            y: {
              display: true,
              min: 0,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        },
        data: { datasets: [] },
      },
      chartDataTop: [],
      chartConfigTop: { options: {}, data: { datasets: [] } },
      absVal: 0,
      totalDuration: 10000,
      delayBetweenPoints: 0,

      animation: {},
      previousY: (ctx) => {
        const defaultY = ctx.chart.scales.y.getPixelForValue(100);

        if (ctx.index === 0) return defaultY;

        const meta = ctx.chart.getDatasetMeta(ctx.datasetIndex);
        const prevData = meta?.data?.[ctx.index - 1];

        if (!prevData || typeof prevData.getProps !== "function") {
          return defaultY;
        }

        return prevData.getProps(["y"], true).y;
      },
      playerOptions: {
        inactivityTimeout: 0,
        bigPlayButton: false,
        playbackRates: [], //[0.5, 1.0, 1.5, 2.0]
        autoplay: false, //  true,           。
        muted: true, //              。
        loop: false, //           。
        preload: "auto", //       <video>                 。auto         ,        （       ）
        language: "zh-CN",
        aspectRatio: "16:9", //           ，                 。          -           （  "16:9" "4:3"）
        fluid: true, //  true ，Video.js player       。    ，             。
        sources: [],
        poster: "", //
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "        ，     ", //    Video.js               。
        controlBar: {
          timeDivider: true, //
          durationDisplay: true, //
          remainingTimeDisplay: true, //
          fullscreenToggle: true, //
        },
      },
      playerOptions2: {
        inactivityTimeout: 0,
        bigPlayButton: false,
        playbackRates: [], //[0.5, 1.0, 1.5, 2.0]
        autoplay: false, //  true,           。
        muted: true, //              。
        loop: false, //           。
        preload: "auto", //       <video>                 。auto         ,        （       ）
        language: "zh-CN",
        aspectRatio: "16:9", //           ，                 。          -           （  "16:9" "4:3"）
        fluid: true, //  true ，Video.js player       。    ，             。
        sources: [],
        poster: "", //
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "        ，     ", //    Video.js               。
        controlBar: {
          timeDivider: true, //
          durationDisplay: true, //
          remainingTimeDisplay: true, //
          fullscreenToggle: true, //
        },
      },

      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "fit_as_title",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        category:
          this.$route.query.category ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].category) ||
          "",
        swingno: 0,
        goodstype: "",
        no: 0,
        fit_shotdata_pk: 0,
      },
      fittingno: this.$route.params.fittingno,

      items: { swinginfo: [], totalswinginfo: {} },
      fitinfo: {},
      swingkeyset: new Set(),
      fittinginfo: { goodsinfo: {}, swingdetailinfo: {} },
      memberinfo: { basicinfo: {} },
      videoControl: "",
      context: null,
      animationFlag: false,
    };
  },

  methods: {
    getFitImagePath() {
      const imageList =
        this.fittinginfo &&
        this.fittinginfo.swingdetailinfo &&
        this.fittinginfo.swingdetailinfo.fit_image;

      if (Array.isArray(imageList)) {
        const match = imageList.find((v) => v.fit_image_type_fk == "2");
        return match && match.fit_image_path ? match.fit_image_path : "";
      }

      return "";
    },
    onPlayerReady(playerInstance) {
      // 안전하게 먼저 할당
      this.player1 = playerInstance;
      this.isReady1 = true;

      const videoEl = playerInstance.el().getElementsByTagName("video")[0];

      if (videoEl) {
        videoEl.addEventListener("canplaythrough", () => {
          this.canPlay1 = true;

          // 둘 다 준비됐을 때 동시 재생
          if (!this.isManualPause && this.canPlay1 && this.canPlay2) {
            this.player1.play().catch((e) => console.warn("player1 error", e));
            this.player2.play().catch((e) => console.warn("player1 error", e));
          }
        });
      }

      // 둘 다 준비됐을 때, 각각 playerInstance를 직접 사용
      // if (this.isReady1 && this.isReady2) {
      //   this.player1 &&
      //     this.player1
      //       .play()
      //       .catch((err) => console.warn("player1 play error:", err));
      // }
    },
    onPlayerReady2(playerInstance) {
      // 안전하게 먼저 할당
      this.player2 = playerInstance;
      this.isReady2 = true;

      const videoEl = playerInstance.el().getElementsByTagName("video")[0];

      if (videoEl) {
        videoEl.addEventListener("canplaythrough", () => {
          this.canPlay2 = true;

          // 둘 다 준비됐을 때 동시 재생
          if (!this.isManualPause && this.canPlay1 && this.canPlay2) {
            this.player1.play().catch((e) => console.warn("player2 error", e));
            this.player2.play().catch((e) => console.warn("player2 error", e));
          }
        });
      }

      // 둘 다 준비됐을 때, 각각 playerInstance를 직접 사용
      // if (this.isReady1 && this.isReady2) {
      //   this.player2 &&
      //     this.player2
      //       .play()
      //       .catch((err) => console.warn("player2 play error:", err));
      // }
    },
    get_fittingswinglist() {
      ax.get_fittingswinglist(this.fittingno, this.searchData, (flag, data) => {
        if (flag) {
          this.items = data.fittingswinglist;
          this.fitinfo = data.fitinfo;
          if (data.fittingswinglist.swinginfo.length) {
            this.searchData.fit_shotdata_pk =
              data.fittingswinglist.swinginfo[0].fit_shotdata_pk || 0;

            this.get_fittingswingview(
              this.fittingno,
              this.searchData.fit_shotdata_pk
            );

            data.fittingswinglist.swinginfo.forEach((v) => {
              this.swingkeyset.add(v.goodstype);
              const trajectory = [
                v.balltrajectory[0],
                ...v.balltrajectory
                  .slice(1)
                  .filter((item) => !item.every((val) => val === 0)),
              ];
              // const trajectory = v.balltrajectory;

              let datatop_ = [];
              let dataside_ = [];

              trajectory.forEach((point, i) => {
                const yVal = parseFloat(point[0]) * 1; // 기존에 /10 했으니 *10 보정 여부 검토
                const xVal = parseFloat(point[1]) * 1;
                const zVal = parseFloat(point[2]) * 1;

                if (this.absVal < Math.abs(yVal)) {
                  this.absVal = Math.abs(yVal);
                }

                datatop_.push({
                  x: Math.round(zVal),
                  y: yVal,
                });

                dataside_.push({
                  x: Math.round(zVal),
                  y: xVal,
                });
              });

              this.chartDataTop.push({
                data: datatop_,
                fit_shotdata_pk: v.fit_shotdata_pk,
              });

              this.chartDataSide.push({
                data: dataside_,
                fit_shotdata_pk: v.fit_shotdata_pk,
              });
            });

            this.chartConfigTop.options = {
              interaction: {
                intersect: false,
              },
              plugins: {
                tooltip: { enabled: false },

                legend: {
                  display: false,
                },
              },
              scales: {
                x: {
                  type: "linear",
                  suggestedMax: 300,
                },
                y: {
                  display: true,
                  suggestedMax: this.absVal,
                  suggestedMin: -this.absVal,
                },
              },
              pointRadius: 0,

              pointBorderColor: "#D3687F", //포인터 보더 색상
              responsive: true,
              maintainAspectRatio: false,
            };
          }
        } else {
          alert(data.message);
        }
      });
    },
    get_fittingswingview(fittingno, swingno) {
      let fit_oneshot_fk_ = 0;
      this.chartConfigTop.data.datasets = [];
      this.chartConfigSide.data.datasets = [];
      this.chartDataLR = [];
      this.chartDataFB = [];
      this.playerOptions = {
        ...this.playerOptions,
        sources: [],
      };
      this.playerOptions2 = {
        ...this.playerOptions2,
        sources: [],
      };

      ax.get_fittingswingview(fittingno, swingno, (flag, data) => {
        if (flag) {
          this.fittinginfo = data.fittinginfo;
          console.log("swingdetailinfo", this.fittinginfo.swingdetailinfo);
          fit_oneshot_fk_ =
            (this.fittinginfo.swingdetailinfo &&
              this.fittinginfo.swingdetailinfo.fit_shotdata_pk) ||
            0;

          const [first_video_file = "", second_video_file = ""] =
            this.fittinginfo.swingdetailinfo.video_file;

          this.playerOptions = {
            ...this.playerOptions,
            sources: [
              {
                type: "video/mp4",
                src: first_video_file.fit_video_path,
              },
            ],
          };

          this.playerOptions2 = {
            ...this.playerOptions2,
            sources: [
              {
                type: "video/mp4",
                src: second_video_file.fit_video_path,
              },
            ],
          };

          this.chartDataTop.sort((a, b) => {
            return b.fit_shotdata_pk == fit_oneshot_fk_ ? 1 : -1;
          });

          this.chartDataSide.sort((a, b) => {
            return b.fit_shotdata_pk == fit_oneshot_fk_ ? 1 : -1;
          });

          this.chartDataTop.forEach((v) => {
            this.chartConfigTop.data.datasets.push({
              borderColor:
                v.fit_shotdata_pk == fit_oneshot_fk_ ? "#ff0000" : "#0000ff",
              borderWidth: 1,
              radius: 0,
              data: v.data,
            });
          });
          this.chartDataSide.forEach((v) => {
            this.chartConfigSide.data.datasets.push({
              borderColor:
                v.fit_shotdata_pk == fit_oneshot_fk_ ? "#ff0000" : "#0000ff",
              borderWidth: 1,
              radius: 0,
              data: v.data,
            });
          });

          const list =
            this.fittinginfo &&
            this.fittinginfo.swingdetailinfo &&
            this.fittinginfo.swingdetailinfo.shotweight_info &&
            this.fittinginfo.swingdetailinfo.shotweight_info.list
              ? this.fittinginfo.swingdetailinfo.shotweight_info.list
              : [];

          this.chartDataLR = [];
          this.chartDataFB = [];

          if (list.length === 2 || list.length === 4) {
            // 문자열을 숫자 배열로 변환
            const parsed = list.map((item) =>
              item.fit_weight_info.split(",").map(parseFloat)
            );

            const len = Math.min(...parsed.map((arr) => arr.length));

            for (let i = 0; i < len; i++) {
              const left = parsed[1][i];
              const right = parsed[0][i];
              const front = list.length === 4 ? parsed[2][i] : 0;
              const back = list.length === 4 ? parsed[3][i] : 0;

              const row = [
                left, // left
                front, // front
                right, // right
                back, // back
              ];
              this.wordLR.push(row);

              // 좌우 계산
              let left_right = (left / (left + right)) * 100;
              left_right = isNaN(left_right) ? 0 : left_right;

              // 전후 계산
              let front_back = (front / (front + back)) * 100;
              front_back = isNaN(front_back) ? 0 : front_back;

              this.chartDataLR.push({ x: i, y: left_right });
              this.chartDataFB.push({ x: i, y: front_back });
            }
          } else {
            console.warn("fit_weight_info 배열은 2개 또는 4개여야 합니다.");
          }

          this.delayBetweenPoints =
            (this.totalDuration / this.chartDataLR.length) * 0.3;
          const _delayBetweenPoints = 8.4;
          console.log(
            "🚀 ~ file: FittingSwingList.vue:1311 ~ ax.get_fittingswingview ~ _delayBetweenPoints",
            _delayBetweenPoints
          );

          this.animation = {
            onComplete: (context) => {
              // console.log("animation finished");

              this.context = context;

              // context.chart.update();
            },
            x: {
              type: "number",
              easing: "linear",

              duration: _delayBetweenPoints,

              from: NaN, // the point is initially skipped\
              // loop: true,

              delay(ctx) {
                if (ctx.type !== "data" || ctx.xStarted) {
                  return 0;
                }
                ctx.xStarted = true;

                return ctx.index * _delayBetweenPoints;
              },
            },
            y: {
              type: "number",
              easing: "linear",

              duration: _delayBetweenPoints,
              from: this.previousY,
              // loop: true,

              delay(ctx) {
                if (ctx.type !== "data" || ctx.yStarted) {
                  return 0;
                }
                ctx.yStarted = true;
                return ctx.index * _delayBetweenPoints;
              },
            },
          };
          this.chartConfig = {
            data: {
              datasets: [
                {
                  borderColor: "#00b34a",
                  borderWidth: 1,
                  radius: 0,
                  data: this.chartDataLR,
                },
                {
                  borderColor: "#ff7519",
                  borderWidth: 1,
                  radius: 0,
                  data: this.chartDataFB,
                },
              ],
            },
            options: {
              animation: this.animation,

              onClick: (point, event) => {
                const e = event.pop(); // 한 번만 pop() 하고 변수에 저장
                const frameIndex = e.index;

                const frameRate =
                  this.fittinginfo.swingdetailinfo.fit_total_frames /
                  this.fittinginfo.swingdetailinfo.fit_play_time;

                const currentTime = frameIndex / frameRate;

                this.isManualPause = true;
                // 영상 컨트롤
                if (this.player1 && this.player1.currentTime) {
                  this.player1.currentTime(currentTime);
                  if (this.player1.pause) this.player1.pause();
                }

                if (this.player2 && this.player2.currentTime) {
                  this.player2.currentTime(currentTime);
                  if (this.player2.pause) this.player2.pause();
                }

                console.log("event : ", event);
                console.log("point : ", point);
              },
              interaction: {
                intersect: false,
              },
              plugins: {
                tooltip: {
                  // enabled: false,

                  callbacks: {
                    label: (context) => {
                      let label = "";

                      // if (label) {
                      //   label += ": ";
                      // }
                      if (context.dataIndex !== null) {
                        // console.log(this.wordLR[context.dataIndex]);

                        let left_ = 0;
                        let right_ = 0;
                        let front_ = 0;
                        let back_ = 0;

                        const word =
                          this.wordLR &&
                          Array.isArray(this.wordLR) &&
                          this.wordLR[context.dataIndex] &&
                          this.wordLR[context.dataIndex].length >= 4
                            ? this.wordLR[context.dataIndex]
                            : null;

                        if (word) {
                          const L = parseInt(word[0]) || 0;
                          const F = parseInt(word[1]) || 0;
                          const R = parseInt(word[2]) || 0;
                          const B = parseInt(word[3]) || 0;

                          const lrSum = L + R;
                          const fbSum = F + B;

                          left_ = lrSum > 0 ? (L / lrSum) * 100 : 0;
                          right_ = lrSum > 0 ? (R / lrSum) * 100 : 0;
                          front_ = fbSum > 0 ? (F / fbSum) * 100 : 0;
                          back_ = fbSum > 0 ? (B / fbSum) * 100 : 0;

                          // 보정 (0~100)
                          left_ = Math.max(0, Math.min(100, left_));
                          right_ = Math.max(0, Math.min(100, right_));
                          front_ = Math.max(0, Math.min(100, front_));
                          back_ = Math.max(0, Math.min(100, back_));
                        }

                        label = [
                          "L: " +
                            Math.round(left_) +
                            " R: " +
                            Math.round(right_),
                          "F: " +
                            Math.round(front_) +
                            " B: " +
                            Math.round(back_),
                        ];
                      }

                      return label;
                    },
                  },
                },
                legend: {
                  display: false,
                },
              },
              scales: {
                x: {
                  display: false,
                  type: "linear",
                },
                y: {
                  display: false,
                },
              },
              responsive: true,
              maintainAspectRatio: false,
            },
          };

          this.wordLR.forEach((v, i) => {
            setTimeout(() => {
              let left = 0;
              let right = 0;
              let front = 0;
              let back = 0;

              left = (parseInt(v[0]) / (parseInt(v[0]) + parseInt(v[2]))) * 100;
              left = left < 0 || isNaN(left) ? 0 : left;
              left = left > 100 ? 100 : left;

              right =
                (parseInt(v[2]) / (parseInt(v[0]) + parseInt(v[2]))) * 100;
              right = right < 0 || isNaN(right) ? 0 : right;
              right = right > 100 ? 100 : right;

              front =
                (parseInt(v[1]) / (parseInt(v[1]) + parseInt(v[3]))) * 100;

              front = front < 0 || isNaN(front) ? 0 : front;
              front = front > 100 ? 100 : front;

              back = (parseInt(v[3]) / (parseInt(v[1]) + parseInt(v[3]))) * 100;

              back = back < 0 || isNaN(back) ? 0 : back;
              back = back > 100 ? 100 : back;

              this.$refs.chartDataL.value = Math.trunc(left);
              this.$refs.chartDataR.value = Math.trunc(right);
              this.$refs.chartDataF.value = Math.trunc(front);
              this.$refs.chartDataB.value = Math.trunc(back);

              // display(name);
            }, i * 7);
          });

          console.log(this.fittinginfo);
        } else {
          alert(data.message);
        }
      });
    },

    onPlayerPlay(player) {
      console.log("onPlayerPlay");
      console.log(player);

      if (this.animationFlag && this.context) {
        this.animationFlag = false;
        this.context.chart.update();

        this.wordLR.forEach((v, i) => {
          setTimeout(() => {
            let left = 0;
            let right = 0;
            let front = 0;
            let back = 0;

            left = (parseInt(v[0]) / (parseInt(v[0]) + parseInt(v[2]))) * 100;
            left = left < 0 || isNaN(left) ? 0 : left;
            left = left > 100 ? 100 : left;

            right = (parseInt(v[2]) / (parseInt(v[0]) + parseInt(v[2]))) * 100;
            right = right < 0 || isNaN(right) ? 0 : right;
            right = right > 100 ? 100 : right;

            front = (parseInt(v[1]) / (parseInt(v[1]) + parseInt(v[3]))) * 100;

            front = front < 0 || isNaN(front) ? 0 : front;
            front = front > 100 ? 100 : front;

            back = (parseInt(v[3]) / (parseInt(v[1]) + parseInt(v[3]))) * 100;

            back = back < 0 || isNaN(back) ? 0 : back;
            back = back > 100 ? 100 : back;

            this.$refs.chartDataL.value = Math.trunc(left);
            this.$refs.chartDataR.value = Math.trunc(right);
            this.$refs.chartDataF.value = Math.trunc(front);
            this.$refs.chartDataB.value = Math.trunc(back);

            // display(name);
          }, i * 7);
        });
      }
    },
    onPlayerPause(player) {
      console.log("onPlayerPause");
      console.log(player.cache_.currentTime);
    },
    setPlayerframe(frame, videoControl) {
      this.videoControl = videoControl;
      console.log("frame", frame);
      this.isManualPause = true;
      this.player1.currentTime(
        frame /
          (this.fittinginfo.swingdetailinfo.fit_total_frames /
            this.fittinginfo.swingdetailinfo.fit_play_time)
      );
      this.player1.pause();

      this.player2.currentTime(
        frame /
          (this.fittinginfo.swingdetailinfo.fit_total_frames /
            this.fittinginfo.swingdetailinfo.fit_play_time)
      );
      this.player2.pause();
    },
    onPlayerEnded(player) {
      console.log("onPlayerEnded");
      console.log(player);
      if (this.context) {
        const meta0 = this.context.chart.getDatasetMeta(0);
        const meta1 = this.context.chart.getDatasetMeta(1);
        for (let i = 0; i < this.chartDataFB.length; i++) {
          const ctx0 = meta0.controller.getContext(i);
          const ctx1 = meta1.controller.getContext(i);
          ctx0.xStarted = ctx0.yStarted = false;
          ctx1.xStarted = ctx1.yStarted = false;
        }

        this.animationFlag = true;
      }
    },
    // playerReadied(player) {
    //   console.log("playerReadied");
    //   console.log(player);

    // },
    // onPlayerTimeupdate(player) {
    //   console.log("onPlayerTimeupdate");
    //   console.log(player);
    // },
    average(arr) {
      // console.log("arr", arr);
      return (
        arr.reduce((p, c) => parseFloat(p) + parseFloat(c), 0) / arr.length
      );
    },
    printPage() {
      window.print();
    },
  },
  created() {
    this.get_fittingswinglist();
  },
  watch: {
    "$route.params": function () {
      this.noticeno = parseInt(this.$route.params.noticeno);
      this.get_fittingswinglist();
    },
    "searchData.goodstype": function (newVal) {
      let item = null;
      item = this.items.swinginfo.filter((v) =>
        newVal ? v.goodstype == newVal : true
      );
      // this.searchData.no = item.length ? item[0].fit_shotdata_pk : "";
      this.searchData.no = "0";
    },
    "searchData.no": function (newVal) {
      if (newVal != "0") this.get_fittingswingview(this.fittingno, newVal);
    },
  },
};
</script>
